import { useRequiredContext } from "@redotech/react-util/context";
import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { memo, useContext } from "react";
import { matchPath, useLocation } from "react-router-dom";

export const MarketingAgentItems = memo(function MarketingAgentItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const location = useLocation();
  const team = useContext(TeamContext);
  const marketingAgentEnabled =
    team?.settings.marketing?.marketingAgent?.enabled ?? false;

  const { data: splitInfo } = useRpcQuery(RedoMarketingRpcClientContext, {
    method: "getMarketingAgentSplitInfo",
    args: {},
    options: { enabled: marketingAgentEnabled },
  });

  if (!marketingAgentEnabled) {
    return null;
  }

  const splitActive = splitInfo?.isActive === true;
  const marketingAgentBaseUrl = routes.marketingAgentHref;
  const anyChildSelected = !!matchPath(
    `${marketingAgentBaseUrl}/*`,
    location.pathname,
  );

  if (!splitActive) {
    return (
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.marketingAgentHref }}
        FilledIcon={AiStarIcon}
        friendlyName="Marketing Agent"
        id="marketing-agent"
        UnfilledIcon={AiStarIcon}
      />
    );
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.marketingAgentHref }}
      anyChildSelected={anyChildSelected}
      FilledIcon={AiStarIcon}
      friendlyName="Marketing Agent"
      id="marketing-agent"
      UnfilledIcon={AiStarIcon}
    >
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getMarketingAgentSubRoute("dashboard"),
        }}
        friendlyName="Split Test"
        id="marketing-agent-dashboard"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getMarketingAgentSubRoute("conversations"),
        }}
        friendlyName="Conversations"
        id="marketing-agent-conversations"
      />
    </RedoSecondaryNavItem>
  );
});
